import translation from './translation.json'
import common from './common.json'
import yup from './yup.json'
import moment from './moment.json'

const en_SA = {
  app: translation,
  common,
  yup,
  moment,
}

export default en_SA
